import React,{useEffect,useState} from 'react';
import ManualRegister from './ManualRegister';
import {identityRequest} from '../services/identity/nuban';
export default function RegistrationEntry(){
 const [consentVersion,setConsentVersion]=useState('');
 const [status,setStatus]=useState('loading'),[attempt,setAttempt]=useState(0);
 useEffect(()=>{
  let active=true;
  setStatus('loading');setConsentVersion('');
  const timer=setTimeout(()=>{if(active){active=false;setStatus('error');}},10000);
  identityRequest('/api/registration/mode').then(r=>{if(active){setConsentVersion(r.consent_version||'');setStatus(r.manual_signup===true&&r.consent_version?'available':'disabled');}}).catch(()=>{if(active)setStatus('error');}).finally(()=>clearTimeout(timer));
  return()=>{active=false;clearTimeout(timer);};
 },[attempt]);
 return <ManualRegister consentVersion={consentVersion} availability={status} onRetryAvailability={()=>setAttempt(n=>n+1)}/>;
}
